import { FormattedMessage } from 'react-intl';
import MinimalLayout from '../layout/MinimalLayout';
import LocalizationProvider from '../lang/LocalizationProvider';
import { getBoldText, getLink } from '../common/FormatMessageComponents';
import fixelWatImage from '../../../assets/icons/fixel-wat.svg';
import styles from './ErrorPage.scss';

const ErrorPage = ({ eventId = '' }: { eventId?: string }) => (
  <LocalizationProvider>
    <MinimalLayout>
      <main className={styles.main}>
        <div className={styles.textBlock}>
          <h1>
            <FormattedMessage id="webError.title" defaultMessage="Something went wrong" />
          </h1>
          <span>
            <FormattedMessage
              id="webError.subtitle"
              defaultMessage="We’ve encountered an unexpcted error.{br}Please, <tryAgainLink>try again</tryAgainLink> later or <supportLink>contact our support</supportLink> for assistance."
              values={{
                br: <br />,
                tryAgainLink: getLink(window.location.href),
                supportLink: getLink('https://support.clearvpn.com/hc/requests/new', true),
              }}
            />
          </span>

          {eventId && (
            <div>
              <FormattedMessage
                id="webError.errorReference"
                defaultMessage="Error report number: <b>{eventId}</b>"
                values={{
                  b: getBoldText(),
                  eventId,
                }}
              />
            </div>
          )}
        </div>

        <img src={fixelWatImage} width="162" height="154" alt="" />
      </main>
    </MinimalLayout>
  </LocalizationProvider>
);

export default ErrorPage;
